module.exports = __webpack_public_path__ + "static/media/AI.a0d73252.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AI.svg
// module id = 187
// module chunks = 0